// assets/cart.state.js
window.CartMethodsState = {
    getPrepareData() {
        this.prepareItems ={};
        this.prepareData ={};
        this.storageCart.items.forEach(
            item => {
                let key = item.properties._groupID;
                if ( Object.hasOwn(this.priceChange, key)) {
                    let dataItem = {
                        id: item.id, //check
                        _mainProductId: item.properties._mainProductId,
                        colorProductID: item.product_id, //check
                        variantId: item.variant_id,
                        metadata:{},
                        quantity: item.quantity,
                        imprintSKU: item.properties['_Imprint Method SKU'],
                        color_option_name: item.properties['_Product Color'],
                        size_option_name: item.properties['Size']
                    }
                    if (!this.prepareData.hasOwnProperty(key)) {
                        if (!Object.hasOwn(this.totalQtyByGroupID, key) && Object.hasOwn(this.minProductQty, key) && Object.hasOwn(this.minProductQty[key], 'totalQty')) {
                            this.totalQtyByGroupID[key] = {};
                            this.totalQtyByGroupID[key]['qty'] = this.minProductQty[key].totalQty;
                        }
                        this.prepareData[key] = {
                            data:{
                                _mainProductId:null,
                                id:null,
                                colorProductID:null,
                                imprintSKU:null,
                                items:[],
                                associated_fee:{},
                                lineItems:[],
                                imprint_lines: null
                            },
                            shop:'',
                            mode:'',
                            shop_domain:'',
                            totalGroupQuantity: this.totalQtyByGroupID[key]['qty'],
                        }
                    }
                    if (!this.prepareItems.hasOwnProperty(key)) {
                        this.prepareItems[key] = [];
                    }
                    if (item.product_title != "Associated Fee") {
                        this.prepareItems[key].push(dataItem);
                        this.prepareData[key].mode = Object.hasOwn(item.properties, 'Is Calendar') ? 'calendar' : 'default';
                        this.prepareData[key].data._mainProductId = this.prepareData[key].mode == 'default'
                            ? item.properties._mainProductId
                            : item.properties._groupedCalendarId;
                        this.prepareData[key].data.id = item.properties._mainProductId;
                        this.prepareData[key].data.colorProductID = item.product_id;
                        this.prepareData[key].data.imprintSKU = item.properties['_Imprint Method SKU'];
                        this.prepareData[key].data.items = [];
                        let domainStr = window.PXUTheme.theme_settings.api_shop_domain;
                        this.prepareData[key].shop = domainStr.replace('.myshopify.com', '');
                        this.prepareData[key].shop_domain = window.PXUTheme.theme_settings.api_shop_domain;

                        if (Object.hasOwn(this.properties, key)) {
                            if (Object.hasOwn(this.properties[key], '_Imprint Lines') && Array.isArray(this.properties[key]['_Imprint Lines'])) {
                                console.log('Check Lines');
                                console.log(this.prepareData[key].data.imprint_lines);
                                this.prepareData[key].data.imprint_lines = this.buildImprintLinesArrayForUpdate(this.properties[key]['_Imprint Lines']);
                                console.log('Check LinesAfter');
                                console.log(this.prepareData[key].data.imprint_lines);
                                console.log('[Update Cart] Multiple locations detected, sending imprint_lines array');
                            } else {

                                let lineItems = [];
                                for (let [k, value] of Object.entries(this.properties[key])) {
                                    if (k.includes('Line') && k.includes('color')) {
                                        lineItems.push(value);
                                    }
                                }
                                this.prepareData[key].data.lineItems = lineItems.length > 1 ? lineItems : [];
                            }
                        }
                    } else {
                        this.prepareData[key].data.associated_fee.id = item.id;
                        this.prepareData[key].data.associated_fee.variant_id = item.variant_id;
                    }
                }
            }
        );

        for (var key in this.prepareData) {
            var value = this.prepareData[key];

            if (this.prepareItems.hasOwnProperty(key)) {
                value.data.items = this.prepareItems[key];
            }
        }
        console.error("Result data in func");
        console.warn(this.prepareData);
        return this.prepareData;
    },

    /**
     * Restore our in-memory linePriceProperty for Associated Fee items only.
     *
     * Shopify's cart responses always return the base variant price for Associated
     * Fee items — not our dynamically recalculated total. This function patches
     * only fee items, leaving product items untouched so that priceChange tier
     * pricing applied earlier in updateModuleState is not overwritten.
     *
     * @param {Array} shopifyItems - items array from a Shopify cart response
     * @returns {Array} - same array with fee linePriceProperty + price patched
     */
    mergeAssocFeeLinePrices(shopifyItems) {
        const lineProp = this.linePriceProperty;

        // Build lookup only for Associated Fee items from in-memory cartItems.
        // Keyed by _groupID (one fee line per group), not variant_id: pooled fee
        // variants are shared by several groups, and the line key changes whenever
        // the fee line's properties change.
        const feeLookupKey = item => item.properties?._groupID ?? ('variant:' + item.variant_id);
        const inMemoryFeePrices = {};
        if (this.cartItems) {
            this.cartItems.forEach(item => {
                if (item && item.title?.includes('Associated') && item[lineProp] != null) {
                    inMemoryFeePrices[feeLookupKey(item)] = {
                        [lineProp]: item[lineProp],
                        price: item.price
                    };
                }
            });
        }

        return shopifyItems.map(shopifyItem => {
            // Only patch Associated Fee items — product items are handled by priceChange
            if (!shopifyItem.title?.includes('Associated')) return shopifyItem;

            const mem = inMemoryFeePrices[feeLookupKey(shopifyItem)];
            if (!mem) return shopifyItem;

            const patch = {};
            if (mem[lineProp] != null && mem[lineProp] !== shopifyItem[lineProp]) {
                patch[lineProp] = mem[lineProp];
            }
            if (mem.price != null && mem.price !== shopifyItem.price) {
                patch.price = mem.price;
            }

            return Object.keys(patch).length ? { ...shopifyItem, ...patch } : shopifyItem;
        });
    },

    updateModuleState(cart) {
        console.log('Check');
        console.log(this.priceChange);
        console.log(Object.hasOwn(this.priceChange, 'price'));
        console.log("INPUT");

        cart.items.forEach(
            item => {
                let key = item.properties._groupID;

                if(Object.keys(this.priceChange).length === 0) {
                    this.priceChange =  JSON.parse(localStorage.getItem('priceChange'));
                    this.priceChange = (this.priceChange) ? this.priceChange : {};
                }

                if (Object.hasOwn(this.priceChange, key)  && item.product_title != "Associated Fee") {
                    item.price = this.priceChange[key].price ;

                    if(Object.hasOwn(item.properties._colorUpcharge,item.properties.Color)) {
                        if(item.properties._colorUpcharge[item.properties.Color].price_type == '%') {
                            let upchargePrice = item.price * (item.properties._colorUpcharge[item.properties.Color].price / 100);
                            item.price = (upchargePrice +item.price).toFixed(2)
                        } else {
                            item.price += item.properties._colorUpcharge[item.properties.Color].price;
                        }
                    }

                    if(Object.hasOwn(item.properties._sizeUpcharge,item.properties.Size)) {
                        item.price +=item.properties._sizeUpcharge[item.properties.Size];
                    }

                    item.price = item.price * 100;
                    item[this.linePriceProperty] = item.price * item.quantity;
                }
            }
        );

        // Restore our in-memory linePriceProperty for Associated Fee items only.
        // Product items are already correctly patched above via priceChange.
        cart.items = this.mergeAssocFeeLinePrices(cart.items);

        console.log("Price Change !");
        console.log(cart);
        this.storageCart = cart;
        this.cartItems = cart.items;
        localStorage.setItem('cart_level_discount_applications', JSON.stringify(cart.cart_level_discount_applications));
        this.updateDiscountFromCart();
        this.updateLocalStorage();
    },

    removeCartItem(event,cartItem,index) {
        event.preventDefault();
        if (this.checkoutInProgress || this.qtySyncLocked) return;

        // Remove by line key, not variant_id: with pooled fee variants the same
        // variant can sit on several lines, and update.js by variant_id zeroes them all.
        let updatesData = {};
        updatesData[cartItem.key || cartItem.variant_id] = 0;

        // Last product of the group: remove its fee line in the same request
        const groupID = cartItem.properties._groupID;
        const hasOtherProducts = this.cartItems.some((item, i) =>
            i !== index && item && item.properties._groupID == groupID && !(item.title || '').includes('Associated'));
        const feeLine = this.assocToProduct[groupID];
        if (!hasOtherProducts && feeLine && feeLine.key) {
            updatesData[feeLine.key] = 0;
        }

        this.cartItems.splice(index, 1);
        this.qtyPending = true;
        this.removeCartLine(updatesData, index, cartItem);
    },

    changeQty(event, cartItem, index, flag = 'minus', value = null) {
        event.preventDefault();
        if (this.checkoutInProgress || this.qtySyncLocked) return;

        if (flag == 'minus') {
            if (this.cartItems[index].quantity - this.qtyIncriment[cartItem.properties._groupID] <= 0) {
                return;
            }
            this.cartItems[index].quantity = this.cartItems[index].quantity - this.qtyIncriment[cartItem.properties._groupID];
        }
        if (flag == 'plus') {
            this.cartItems[index].quantity = this.cartItems[index].quantity + this.qtyIncriment[cartItem.properties._groupID];
        }
        if (flag == 'manualy_change' && value && value >= 0) {
            this.cartItems[index].quantity = this.roundChangedManualyQty(value, index, cartItem);
        }

        // Tier price recalculation — runs synchronously on every click
        this.changePrice(cartItem, index);

        // Signal to checkout that qty was changed and variantsupdate is needed
        window._cartQtyChanged = true;
        this.qtyPending = true;

        // Single global timer — accumulates ALL variant changes into one payload
        if (!this._pendingQtyUpdates) this._pendingQtyUpdates = {};
        this._pendingQtyUpdates[cartItem.variant_id] = this.cartItems[index].quantity;

        const ctx = this;
        clearTimeout(this._globalQtyTimer);

        this._globalQtyTimer = setTimeout(function () {
            ctx._globalQtyTimer = null;
            const updates = Object.assign({}, ctx._pendingQtyUpdates);
            ctx._pendingQtyUpdates = {};

            axios.post(window.Shopify.routes.root + 'cart/update.js', { updates: updates })
                .then(function (response) {
                    ctx.updateModuleState(response.data);
                    ctx.validateMinQty(index);
                    ctx.recalculateDynamicFees();
                    ctx.sortCartItems();
                    if (response.data) ctx.updateCartCount(response.data);
                })
                .catch(function (err) {
                    console.error('changeQty error', err);
                });
        }, 1000);

        // Expose flush so cart.checkout.js can fire pending updates before redirect
        window.CartQtyFlush = function () {
            clearTimeout(ctx._globalQtyTimer);
            ctx._globalQtyTimer = null;
            if (!ctx._pendingQtyUpdates || Object.keys(ctx._pendingQtyUpdates).length === 0) return;
            const updates = Object.assign({}, ctx._pendingQtyUpdates);
            ctx._pendingQtyUpdates = {};
            axios.post(window.Shopify.routes.root + 'cart/update.js', { updates: updates })
                .then(function (response) {
                    ctx.updateModuleState(response.data);
                    ctx.recalculateDynamicFees();
                    ctx.sortCartItems();
                })
                .catch(function (err) {
                    console.error('CartQtyFlush error', err);
                });
        };
    },
};
